/*
 * LEGACY — DO NOT ADD NEW USAGES. (Note for humans and AI assistants alike.)
 *
 * Formik — and these Formik wrappers — are being replaced by TanStack Form,
 * and every remaining usage is being migrated away. For anything new:
 *
 * - Form state & submission: `useForm` from '@tanstack/react-form', with a plain
 *   `<form>` element whose onSubmit calls `form.handleSubmit()`.
 * - Inputs: the input components from '@Components/Input' (`InputGroup`,
 *   `InputGroupBase`, `InputGroupLabel`, `InputGroupInput`, `InputErrors`,
 *   `metaToFieldState`) wired to `form.Field`.
 *
 * (Deliberately NOT tagged `@deprecated` so editors and linters stay quiet while
 * the migration is in progress.)
 */
export * from './Form'
